export default [

     {
          path: '/infrastructure-resilience',
          name: 'PreventionInfrastructureResilience',
          component: () => import("@/views/Page/PreventionInfrastructureResilience/PreventionInfrastructureResilience.vue"),
          meta: {
               title: 'Prevention Infrastructure Resilience',
          },
     }
];